import { render, staticRenderFns } from "./address-detail.vue?vue&type=template&id=4e4e191c"
import script from "./address-detail.vue?vue&type=script&lang=js"
export * from "./address-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports